/* unplugin-vue-components disabled */import { render } from "./audios.vue?vue&type=template&id=588df060&scoped=true"
import script from "./audios.vue?vue&type=script&lang=js"
export * from "./audios.vue?vue&type=script&lang=js"

import "./audios.vue?vue&type=style&index=0&id=588df060&scoped=true&lang=scss"
import "./audios.vue?vue&type=style&index=1&id=588df060&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588df060"]])

export default __exports__